import React from "react";
import {
  Create,
  Edit,
  TextInput,
  SelectArrayInput,
  ReferenceArrayInput,
  BooleanInput,
  LongTextInput,
  ImageField
} from "admin-on-rest";
import RichTextInput from "aor-rich-text-input";
import IconTitle from "../components/icon_title";
import PageForm from "./PageForm";
import ImageOlaSingleInput from "../components/image";
import DependentImageInput from "../components/image/DependentImageInput";

//const FullNameField = ({ record }) => <span>{record.first_name} {record.last_name}</span>;
const pageDefaultValue = { marketers: [], collections: [] };
/*<ReferenceInput label="resources.pages.fieldList.marketer" source="marketer_id" reference="marketers" allowEmpty>
  <SelectInput optionText={<FullNameField />} optionValue="id" />
</ReferenceInput>*/

const PageForm1 = props => (
  <PageForm {...props} defaultValue={pageDefaultValue}>
    <TextInput label="resources.pages.fieldList.name" source="name" />
    <TextInput label="resources.pages.fieldList.slug" source="slug" />
    <BooleanInput label="resources.pages.fieldList.active" source="active" />
    <RichTextInput
      label="resources.pages.fieldList.description"
      source="description"
      name="description"
      toolbar={toolbar}
    />
    <DependentImageInput dependsOn={"name"} {...props}>
      <ImageOlaSingleInput
        source="banners.desktop"
        toValue={props.toValue}
        labelImage="Desktop"
        label={"resources.pages.fieldList.banners.desktop"}
        accept="image/*"
      >
        <ImageField source="src" title="title" />
      </ImageOlaSingleInput>
    </DependentImageInput>
    <DependentImageInput dependsOn={"name"} {...props}>
      <ImageOlaSingleInput
        source="banners.mobile"
        toValue={props.toValue}
        labelImage="Mobile"
        label={"resources.pages.fieldList.banners.mobile"}
        accept="image/*"
      >
        <ImageField source="src" title="title" />
      </ImageOlaSingleInput>
    </DependentImageInput>
    <ReferenceArrayInput
      label={"resources.pages.fieldList.collections"}
      source="collections"
      reference="collections"
      allowEmpty
      perPage={1000}
    >
      <SelectArrayInput optionText="name" />
    </ReferenceArrayInput>
    <LongTextInput
      label="resources.pages.fieldList.tracking"
      source="tracking"
    />
  </PageForm>
);

export const PageCreate = props => (
  <Create
    {...props}
    title={<IconTitle icon="pages" title={"resources.pages.titleNew"} />}
  >
    <PageForm1 {...props} />
  </Create>
);

export const PageEdit = props => (
  <Edit
    {...props}
    title={<IconTitle icon="pages" title={"resources.pages.titleEdit"} />}
  >
    <PageForm1 {...props} />
  </Edit>
);

const toolbar = [
  [{ header: [1, 2, 3] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ color: [] }, { background: [] }],
  ["image", "code-block"]
];



// WEBPACK FOOTER //
// ./src/pages/Create.js